export default __webpack_public_path__ + "static/media/exploded-view_labels.1f0fd2a4.png";